import {createAction} from 'redux-actions'

export const clearLocalStorage = createAction('CLEAR_LOCAL_STORAGE')

export const uiSetValue = createAction(
  'ui/setValue',
  (name, value, merge = true, version = null, initialValue = undefined) => ({
    value,
    merge,
    version,
    initialValue,
  }),
  name => ({name})
)

// assume shape of root.ui[name] is a dict
// merge value (also needs to be a dict) into root.ui[name]
// this also reproduces the setUI action from uix/connect (out of favor since react hooks)
export const mergePersisted = (name, value) => uiSetValue(name, value, true)

// replace value
export const setPersisted = (name, value) => uiSetValue(name, value, false)

export const clearPartPersistence = createAction('CLEAR_PART_PERSISTENCE', partName => ({partName}))
